import { TextboxControl } from "@/Common/Components/Inputs/TextboxControl";
import { ExpressEditMode } from "@/Common/Models/Patient/PatientEnums";
import { PatientIdentifier } from "@/Common/Models/Patient/PatientIdentifier";
import { IPatientIdentifiersModel } from "@/Common/Models/Patient/UI/Profile/IPatientIdentifiersModel";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import { HealthCardsEdit } from "@/Patient/Components/Profile/Identifiers/HealthCardsEdit";
import { OtherIdentifiersEdit } from "@/Patient/Components/Profile/Identifiers/OtherIdentifiersEdit";

interface IPatientProfileIdentifiersProps {
    Model: IPatientIdentifiersModel;
    AutofocusOperation?: ExpressEditMode;
}

class IdentifiersEdit extends React.Component<IPatientProfileIdentifiersProps, any> {
    public render(): JSX.Element {
        var model: IPatientIdentifiersModel = (this.props.Model) ? this.props.Model : null;

        return (
            <div className="patient-prof">
                <div className="scrollable patient-identifiers" data-cy="patient-identifiers-edit">
                    <div className="block separated">
                        <div className="flex-container heading">
                            <h3 className="h thin-font">{cacheStore.GetString("HealthCard")}</h3>
                        </div>
                        <div className="psingle-column wider centered">
                            <HealthCardsEdit
                                healthCards={model.get("HealthCards").toArray()}
                                autofocusOperation={this.props.AutofocusOperation}
                                onAddHealthCard={this.OnAddHealthCard}
                                onRemoveHealthCard={this.OnRemoveHealthCard}
                                onNamNumberChanged={this.OnNamNumberChanged}
                                onNamCountryChanged={this.OnNamCountryChanged}
                                onNamProvinceChanged={this.OnNamProvinceChanged}
                                onNamVersionChanged={this.OnNamVersionChanged}
                                onNamExpirationDateChange={this.OnNamExpirationDateChange}
                            />
                        </div>
                    </div>

                    <div className="block separated">
                        <div className="flex-container heading">
                            <h3 className="h thin-font">{cacheStore.GetString("FileNumbersLabel")}</h3>
                        </div>

                        <div className="psingle-column wider centered">
                            <table>
                                <tbody>
                                    <tr>
                                        <td className="c1">
                                            <label className="form-label">{cacheStore.GetString("Identifier1Label")}</label>
                                        </td>
                                        <td className="c2">
                                            <TextboxControl dataCy="patientProfile-fileNumbers-identifier1" value={model.get("Identifier01")} className="form-control" operation={LocalPatientOperations.Profile.Identifiers_Identifier01Change} />
                                        </td>
                                        <td className="c3" rowSpan={3} />
                                    </tr>
                                    <tr>
                                        <td className="c1">
                                            <label className="form-label">{cacheStore.GetString("Identifier2Label")}</label>
                                        </td>
                                        <td className="c2">
                                            <TextboxControl dataCy="patientProfile-fileNumbers-identifier2" value={model.get("Identifier02")} className="form-control" operation={LocalPatientOperations.Profile.Identifiers_Identifier02Change} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="c1">
                                            <label className="form-label">{cacheStore.GetString("Identifier3Label")}</label>
                                        </td>
                                        <td className="c2" style={{ paddingBottom: "15px" }}>
                                            <TextboxControl dataCy="patientProfile-fileNumbers-identifier3" value={model.get("Identifier03")} className="form-control" operation={LocalPatientOperations.Profile.Identifiers_Identifier03Change} />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="block separated">
                        <div className="flex-container heading">
                            <h3 className="h thin-font">{cacheStore.GetString("OtherIdentifierslabel")}</h3>
                        </div>
                        <div className="psingle-column wider centered">
                            <OtherIdentifiersEdit
                                identifiers={model.get("OtherIdentifiers").toArray()}
                                onAddOtherId={() => this.OnAddOtherId()}
                                onOtherIdentifierNameChange={(id, value) => this.OnOtherIdentifierNameChange(id, value)}
                                onOtherIdentifierNumberChange={(id, value) => this.OnOtherIdentifierNumberChange(id, value)}
                                onRemoveOtherId={id => this.OnRemoveOtherId(id)}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    public componentDidMount(): void {
        $(window).trigger("resize");

        // auto focus on NAM if we are here from a banner label click
        if (this.props.AutofocusOperation == ExpressEditMode.NAM) {
            var item = $("#healthNumber0");
            if (item)
                item.focus();
        }
    }

    private OnAddOtherId(): void {
        sessionStore.dispatch(LocalPatientOperations.Profile.Identifiers_AddOtherId);
    }

    private OnRemoveOtherId(item: PatientIdentifier): void {
        sessionStore.dispatch(LocalPatientOperations.Profile.Identifiers_RemoveOtherId, { value: item.HealthIdentification_id });
    }

    private OnOtherIdentifierNameChange(item: PatientIdentifier, value: string): void {
        sessionStore.dispatch(LocalPatientOperations.Profile.Identifiers_OtherIdOrganizationChange, { item, value });
    }

    private OnOtherIdentifierNumberChange(item: PatientIdentifier, value: string): void {
        sessionStore.dispatch(LocalPatientOperations.Profile.Identifiers_OtherIdNumberChange, { item, value });
    }

    private OnAddHealthCard(): void {
        sessionStore.dispatch(LocalPatientOperations.Profile.Identifiers_AddHealthCard);
    }

    private OnRemoveHealthCard(item: PatientIdentifier): void {
        sessionStore.dispatch(LocalPatientOperations.Profile.Identifiers_RemoveHealthCard, { value: item.HealthIdentification_id });
    }

    private OnNamNumberChanged(item: PatientIdentifier, value: string): void {
        sessionStore.dispatch(LocalPatientOperations.Profile.Identifiers_NAMNumberChange, { item, value });
    }

    private OnNamCountryChanged(item: PatientIdentifier, value: string): void {
        sessionStore.dispatch(LocalPatientOperations.Profile.Identifiers_NAMSelectCountry, { item, value });
    }

    private OnNamProvinceChanged(item: PatientIdentifier, value: string): void {
        sessionStore.dispatch(LocalPatientOperations.Profile.Identifiers_NAMSelectProvince, { item, value });
    }

    private OnNamVersionChanged(item: PatientIdentifier, value: string): void {
        sessionStore.dispatch(LocalPatientOperations.Profile.Identifiers_NAMVersionChange, { item, value });
    }

    private OnNamExpirationDateChange(item: PatientIdentifier, value: Date): void {
        sessionStore.dispatch(LocalPatientOperations.Profile.Identifiers_NAMExpirationDateChange, { item, value });
    }
}

export { IdentifiersEdit, IPatientProfileIdentifiersProps };
